import React from 'react';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Articles.module.scss';
import article1 from '../../shared/assets/images/article1.png';
import article2 from '../../shared/assets/images/article2.png';
import article3 from '../../shared/assets/images/article3.png';
import article4 from '../../shared/assets/images/article4.png';

export const ArticlesList = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'Статьи', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));
    return (
        <section id='articles-list'>
            <div className={S.content}>
                <div>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.contentDiv}>
                        <div className={S.articleDiv} onClick={() => navigate('/article1')}>
                            <div className={S.picture}>
                                <img src={article1} alt="article1"/>
                            </div>
                            <div className={S.textDate}>26 фев 2025</div>
                            <div className={S.textTitle}>
                                Ольга Калашникова, начальник управления экологии ПАО «Северсталь»: «Будущее
                                принадлежит тем, кто готовится к нему сегодня, следуя экологическим принципам»
                            </div>
                        </div>
                        <div className={S.articleDiv} onClick={() => navigate('/article2')}>
                            <div className={S.picture}>
                                <img src={article2} alt="article2"/>
                            </div>
                            <div className={S.textDate}>24 апр 2025</div>
                            <div className={S.textTitle}>
                                Цифровизация экономических отношений в энергетике
                            </div>
                        </div>
                        <div className={S.articleDiv} onClick={() => navigate('/article3')}>
                            <div className={S.picture}>
                                <img src={article3} alt="article3"/>
                            </div>
                            <div className={S.textDate}>25 июн 2025</div>
                            <div className={S.textTitle}>
                                Ум, сталь и трубы нашей эпохи
                            </div>
                        </div>
                        <div className={S.articleDiv} onClick={() => navigate('/article4')}>
                            <div className={S.picture}>
                                <img src={article4} alt="article4"/>
                            </div>
                            <div className={S.textDate}>23 дек 2024</div>
                            <div className={S.textTitle}>
                                Цифровизация в обучении ремонтников Уральской Стали
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};